import { render, staticRenderFns } from "./EditActiveStatusDefaultForm.vue?vue&type=template&id=ecda8f50"
import script from "./EditActiveStatusDefaultForm.vue?vue&type=script&lang=js"
export * from "./EditActiveStatusDefaultForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports